module.exports = __webpack_public_path__ + "img/1515058945.cd606a2c.jpg";